<template>
  <section id="admin-model-list">

    <b-card class="admin-page-mobile">
        <b-button
            class="btn-sm mb-1"
          :variant="isMobile ? 'outline-light': 'outline-primary'"
          @click="showModal"
        >
          <feather-icon
              icon="PlusIcon"
              size="22"
              class="align-text-top"
          /> افزودن
        </b-button>
        <v-data-table
            v-bind="{dark : isMobile }"
          :headers="headers"
          :items="desserts"
            :search="search"
          mobile-breakpoint="0"
            loading
            loading-text="Loading... Please wait"
        >
          <template v-slot:top>
            <v-text-field
                v-model="search"
                label="جستجو"
                class="mx-4"
                style=""
            ></v-text-field>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon
                @click="onEditItem(item)"
            >
              mdi-circle-edit-outline
            </v-icon>
            <v-icon
                style="margin-right: 7px"
                @click="onDeleteItem(item)"
            >
              mdi-delete
            </v-icon>
          </template>
          <template v-slot:no-data>
            <v-btn
              variant="gradient-primary"
              @click="initialize"
            >
              بروزرسانی
            </v-btn>
          </template>
        </v-data-table>

        <!-- modal login-->
        <b-modal
          ref="modal-add"
          cancel-variant="outline-secondary"
          ok-title="افزودن"
          cancel-title="بستن"
          centered
          title="مشخصات"
        >
          <validation-observer ref="Validation">
            <b-form>
              <!-- title -->
              <b-form-group
                label="عنوان"
                label-for="vi-title"
              >
                <validation-provider
                  #default="{ errors }"
                  name="فیلد عنوان"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-title"
                      v-model="model.title"
                      placeholder="title"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- پروتکل -->
              <b-form-group
                label="پروتکل"
                label-for="vi-protocol"
              >
                <validation-provider
                  #default="{ errors }"
                  name="فیلد پروتکل"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-protocol"
                      v-model="model.protocol"
                      placeholder="protocol"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- port -->
              <b-form-group
                label="پورت"
                label-for="vi-port"
              >
                <validation-provider
                  #default="{ errors }"
                  name="فیلد پورت"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <feather-icon icon="UserIcon" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-port"
                      v-model="model.port"
                      placeholder="port"
                    />
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-form>
          </validation-observer>
          <template #modal-footer="">
            <b-button
              size="sm"
              variant="danger"
              @click="hideModal"
            >
              بستن
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="modalOk()"
            >
              ذخیره
            </b-button>
          </template>
        </b-modal>
    </b-card>

  </section>
</template>
<script>
import {
  BCard, BCardBody, BModal, BButton, BInputGroup, BInputGroupPrepend, BFormGroup, BFormInput, BCol, BForm,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import router from '@/router'

import ModelService from '@/services/model.service'
import Model from '@/models/model'

import BreadcrumbMobile from '@/layouts/breadcrumb.vue'
import Vue from 'vue'

export default {
  components: {
    BCard,
    BCardBody,
    BButton,
    BModal,
    BInputGroup,
    BInputGroupPrepend,
    BFormGroup,
    BFormInput,
    BCol,
    BForm,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      search: '',
      desserts: [],
      model: new Model('', '', '', ''),
      required,
      isMobile: Vue.prototype.$functions.isMobile(),
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'عنوان',
          align: 'start',
          sortable: false,
          value: 'title',
        },
        { text: 'پروتکل', value: 'protocol' },
        { text: 'پورت', value: 'port' },
        { text: 'تاریخ ایجاد', value: 'creationDate' },
        { text: 'عملیات', value: 'actions', sortable: false },
      ]
    },
  },
  async created() {
    this.$vuetify.rtl = true
    this.initialize()
  },
  mutations: {
    deleteItem(state, payload) {
      state.items.splice(payload, 1)
      // eslint-disable-next-line no-underscore-dangle
    },
  },
  methods: {
    initialize() {
      this.desserts = []
      ModelService.getList().then(
        res => {
          if (res.status === 'success') {
            if ('result' in res && 'data' in res.result && res.result.data.length > 0) {
              for (let i = 0; i <= res.result.data.length - 1; i++) {
                const temp = res.result.data[i]
                temp.creationDate = new Date(temp.creationTime * 1000).toLocaleDateString('fa-IR')
                this.desserts.push(temp)
              }
            }
          }
        },
        error => {
          this.message = (error.response && error.response.data)
                || error.message
                || error.toString()
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'register error',
              text: this.message,
              icon: 'XIcon',
              variant: 'danger',
            },
          })
        },
      )
    },
    addClick() {
      router.push({ name: 'model-add' })
    },
    modalOk() {
      this.locale = 'fa'
      this.$refs.Validation.validate().then(success => {
        if (success) {
          ModelService.add(this.model).then(
            res => {
              if (res.status === 'success') {
                this.initialize()
                this.hideModal()
              }
            },
            error => {
              this.message = (error.response && error.response.data)
                    || error.message
                    || error.toString()
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: this.message,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            },
          )
        }
      })
    },
    onDeleteItem(item) {
      let index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-restricted-globals,no-unused-expressions
      if (confirm('آیا مطمئنید؟')) {
        ModelService.delete({
          // eslint-disable-next-line no-underscore-dangle
          _id: this.desserts[index]._id,
        }).then(
          res => {
            if (res.status !== 'success') {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'register error',
                  text: res.result,
                  icon: 'XIcon',
                  variant: 'danger',
                },
              })
            } else {
              this.desserts.splice(index, 1)
            }
          },
          error => {
            this.message = (error.response && error.response.data)
                  || error.message
                  || error.toString()
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'register error',
                text: this.message,
                icon: 'XIcon',
                variant: 'danger',
              },
            })
          },
        )
      } else {
        index = ''
      }
      // Todo: Make this delete item from store
      // eslint-disable-next-line no-underscore-dangle
    },
    onEditItem(item) {
      const index = this.desserts.indexOf(item)
      // eslint-disable-next-line no-underscore-dangle
      this.model._id = this.desserts[index]._id.toString()
      this.model.title = this.desserts[index].title.toString()
      this.model.protocol = this.desserts[index].protocol.toString()
      this.model.port = this.desserts[index].port.toString()

      this.$refs['modal-add'].show()
    },
    showModal() {
      this.model = new Model('', '', '', '')
      //  this.initializeOption()
      this.$refs['modal-add'].show()
    },
    hideModal() {
      this.$refs['modal-add'].hide()
    },
  },
}
</script>
